import is from '@sindresorhus/is';
import { z } from 'zod';

import { activityTimelineBlockSchema } from './activity-timeline-block';
import { changeProposalBlockSchema } from './change-proposal-block';
import { clarifyOptionsBlockSchema } from './clarify-options-block';
import { questionnaireBlockSchema } from './questionnaire-block';
import { statusUpdateBlockSchema } from './status-update-block';
import { textBlockSchema } from './text-block';

export * from './activity-timeline-block';
export * from './change-proposal-block';
export * from './clarify-options-block';
export * from './questionnaire-block';
export * from './rich-text';
export * from './status-update-block';
export * from './text-block';

const inferBlockType = (input: unknown): unknown => {
    if (!is.plainObject(input)) return input;
    if (is.nonEmptyString(input['type'])) return input;
    if (is.array(input['diffs'])) return { ...input, type: 'change-proposal' };
    if (is.array(input['questions'])) return { ...input, type: 'questionnaire' };
    if (is.array(input['options'])) return { ...input, type: 'clarify-options' };
    if (is.string(input['text'])) return { ...input, type: 'text' };
    return input;
};

export const chatBlockSchema = z.preprocess(
    inferBlockType,
    z.discriminatedUnion('type', [
        activityTimelineBlockSchema,
        textBlockSchema,
        questionnaireBlockSchema,
        changeProposalBlockSchema,
        clarifyOptionsBlockSchema,
        statusUpdateBlockSchema,
    ]),
);

export type ChatBlock = z.infer<typeof chatBlockSchema>;

export type ChatBlockType = ChatBlock['type'];
